import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "KSearchInput";
var classes = {
    listbox: "".concat(PREFIX, "-listbox"),
    option: "".concat(PREFIX, "-option"),
    groupUl: "".concat(PREFIX, "-groupUl"),
    splitButton: "".concat(PREFIX, "-splitButton"),
    serchTextField: "".concat(PREFIX, "-serchTextField"),
    loader: "".concat(PREFIX, "-loader")
};
var StyledKSearchInput = styled(TextField, {
    shouldForwardProp: function (prop) {
        return prop !== "backgroundColor" && prop !== "textColor" && prop !== "inputBorderRadius";
    }
})(function (_a) {
    var _b, _c;
    var theme = _a.theme, backgroundColor = _a.backgroundColor, textColor = _a.textColor, inputBorderRadius = _a.inputBorderRadius;
    return (_b = {
            "& .MuiInputBase-root": {
                backgroundColor: backgroundColor || theme.palette.background["default"],
                color: textColor || theme.palette.text.primary,
                borderRadius: inputBorderRadius || ""
            },
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: textColor
            }
        },
        _b["& .".concat(classes.listbox)] = {
            boxShadow: "0px 6px 14px rgba(0, 0, 0, 0.16)",
            "& [class*=MuiListSubheader]": {
                backgroundColor: backgroundColor || theme.palette.background["default"],
                color: textColor || theme.palette.text.primary,
                top: theme.spacing(-1),
                lineHeight: 1.4
            }
        },
        _b["& .".concat(classes.option)] = {
            paddingLeft: theme.spacing(4),
            fontWeight: "bold",
            "&:focus-within, &:hover, &[data-focus]": {
                backgroundColor: backgroundColor || theme.palette.primary.main,
                color: textColor || theme.palette.background.paper
            }
        },
        _b["& .".concat(classes.groupUl)] = {
            borderBottom: "1px solid ".concat(theme.palette.divider)
        },
        _b["& .".concat(classes.splitButton)] = {
            borderRadius: 0,
            "& .MuiButton-root": {
                borderColor: "transparent !important",
                color: textColor || theme.palette.text.primary,
                backgroundColor: backgroundColor
            }
        },
        _b["&.".concat(classes.serchTextField)] = {
            "& .MuiInputBase-input ": (_c = {
                    borderLeft: textColor ? "1px solid ".concat(textColor) : "1px solid #ccc"
                },
                // In mobile we don't have the select on the left, we don't need the borderLeft then
                _c[theme.breakpoints.down("sm")] = {
                    borderLeft: 0
                },
                _c)
        },
        _b["& .".concat(classes.loader)] = {
            marginRight: theme.spacing(1)
        },
        _b);
});

export { classes, StyledKSearchInput as default };
//# sourceMappingURL=index.styled.js.map
